import useTranslation from 'next-translate/useTranslation';

// Layout
import LayoutLogged from '@/components/layouts/LayoutLogged';

// Utils
import useActiveTreeStructure from '@/utils/hooks/tree-structure/useActiveTreeStructure';

// Lib
import {
    SCHEDULER_COLLABORATION_NOTIFICATIONS,
    SCHEDULER_COLLABORATION_SETTINGS
} from '@/routes/privateRoutes';

// Components
import { WrapperSwitchLayout } from '@/components/layouts/wrappers/WrapperSwitchLayout';
import CollaborationTabs from '@/components/pages/scheduler/collaboration/CollaborationTabs';
import { PageHeaderPopover } from '@/components/layouts/LayoutPlatform/components/PageHeaderRecap/PageHeaderPopover';

type CollaborationWrapperProps = {
    children: React.ReactNode;
};

const CollaborationContentWrapper = ({ children }: CollaborationWrapperProps) => {
    const { t } = useTranslation();
    const { isTreeStructureActivated } = useActiveTreeStructure();

    if (isTreeStructureActivated) {
        const dropdownLinks = [
            {
                href: SCHEDULER_COLLABORATION_NOTIFICATIONS,
                label: t('scheduler:collaboration.tabs.notifications')
            },
            {
                href: SCHEDULER_COLLABORATION_SETTINGS,
                label: t('scheduler:collaboration.tabs.settings')
            }
        ];

        return (
            <>
                <PageHeaderPopover dropdownLinks={dropdownLinks} />
                {children}
            </>
        );
    }

    return (
        <>
            <LayoutLogged.Header>
                <CollaborationTabs />
            </LayoutLogged.Header>
            {children}
        </>
    );
};

const CollaborationWrapper = ({ children }: CollaborationWrapperProps) => {
    return (
        <WrapperSwitchLayout>
            <CollaborationContentWrapper>{children}</CollaborationContentWrapper>
        </WrapperSwitchLayout>
    );
};

export default CollaborationWrapper;
